module.exports = __webpack_public_path__ + "static/media/dep-director.0dbf3d86.png";